export default { copySecretToClipboard, toggleRevealPassword }

function toggleRevealPassword(id) {
  var toggleEl = document.getElementById(id);
  if (toggleEl.type == "text") {
    toggleEl.type = "password";
  } else {
    toggleEl.type = "text";
  }
}

async function copySecretToClipboard(secret) {
  await navigator.clipboard.writeText(secret);
}
